import styled from 'styled-components';
import { Input as SemanticInput } from 'semantic-ui-react';

import {
  Button as ButtonLayoutComponent,
  Segment as SegmentLayoutComponent, Text as TextLayoutComponent,
  Loader as LoaderLayoutComponent,
} from '@playbookux/playbook-web-core';

const BackLink = styled.div`
  margin-top: 20px;
  text-align: center;
  a {
    font-size: 15px;
  }
`;

const BottomContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  margin-top: 30px;
  width: 100%;
`;

const Button = styled(ButtonLayoutComponent)`
  width: 100%;
`;

const Container = styled.form`
  align-items: center;
  display: flex;
  flex-direction: column;
  margin-bottom: 40px;
  margin-left: auto;
  margin-right: auto;
  max-width: 400px;
`;

const ErrorMessage = styled(TextLayoutComponent.Error)``;

const Input = styled(SemanticInput)``;

const Label = styled(TextLayoutComponent.Label)`
  margin-top: 15px;
`;

const Logo = styled.img`
  margin-bottom: 40px;
  margin-top: 75px;
  max-width: 200px;
`;

const Segment = styled(SegmentLayoutComponent)`
  width: 100%;

  &.ui.segment {
    padding: 30px 20px 20px 20px;
  }
`;

const Text = styled(TextLayoutComponent)``;

const Title = styled(TextLayoutComponent.Title)`
  color: ${(props) => props.theme.color.textSignScreen};
  font-size: 18px;
  margin-bottom: 20px;
  width: 100%;
`;

const TitleCenter = styled(TextLayoutComponent.Title)`
  color: ${(props) => props.theme.color.textSignScreen};
  font-size: 18px;
  margin-bottom: 80px;
  width: 100%;
  text-align: center;
`;

const Loader = styled(LoaderLayoutComponent)`
`;

export {
  BackLink,
  BottomContainer,
  Button,
  Container,
  ErrorMessage,
  Input,
  Label,
  Logo,
  Segment,
  Text,
  Title,
  TitleCenter,
  Loader,
};
